<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item label="状态" v-if="props.id">
        <el-switch
          v-model="state.model.status"
          active-text="启用"
          inactive-text="禁用"
          inline-prompt
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <ul class="flex items-center gap-x-3">
        <el-form-item
          label="姓名"
          prop="name"
          :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
          class="flex-1"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="性别"
          prop="sex"
          :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
        >
          <div
            class="rounded px-3 cursor-pointer"
            :class="
              state.model.sex == '男'
                ? ' bg-green-800 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.sex = '男'"
          >
            男
          </div>
          <div
            class="rounded px-3 ml-2 cursor-pointer"
            :class="
              state.model.sex == '女'
                ? ' bg-red-600 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.sex = '女'"
          >
            女
          </div>
        </el-form-item>
      </ul>
      <el-form-item
        label="手机号"
        prop="phone"
        :rules="[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: $phone_rules, trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.phone"></el-input>
      </el-form-item>
      <el-form-item
        label="所属部门"
        prop="admin_role_ids"
        :rules="[
          { required: true, message: '请选择所属部门', trigger: 'blur' },
        ]"
      >
        <el-tree-select
          v-model="state.model.department_id"
          :data="state.bmData"
          node-key="id"
          :expand-on-click-node="false"
          :props="{
            children: 'children',
            label: 'name',
          }"
        >
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadBm"
            >
              刷新
            </el-button>
          </template>
        </el-tree-select>
      </el-form-item>
      <el-form-item
        label="角色权限"
        prop="admin_role_ids"
        :rules="[
          { required: true, message: '请选择角色权限', trigger: 'blur' },
        ]"
      >
        <el-select
          v-model="state.model.admin_role_ids"
          placeholder="--请选择--"
          multiple
        >
          <el-option
            v-for="item in state.jsData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadJs"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="审批角色">
        <el-checkbox-group v-model="state.model.approver_type">
          <el-checkbox :value="1">业务负责人</el-checkbox>
          <el-checkbox :value="2">财务负责人</el-checkbox>
          <el-checkbox :value="3">总经理</el-checkbox>
          <el-checkbox :value="4">出纳</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="职务">
        <el-input v-model="state.model.job"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_getDepartment_tree, data_getAdminRole } from "@/http/data";
import { admin_detail, admin_add, admin_edit } from "@/http/admin";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadBm();
      onLoadJs();
      if (props.id) {
        admin_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;

            state.model = data;
            state.model.leader_type = data.leader_type
              ? data.leader_type.split(",").map((item) => Number(item))
              : [];
          }
        });
      }
    });

    //获取部门
    const onLoadBm = () => {
      data_getDepartment_tree().then((res) => {
        if (res.status == 200) state.bmData = res.data?.data || [];
      });
    };

    //获取角色
    const onLoadJs = () => {
      data_getAdminRole().then((res) => {
        if (res.status == 200) state.jsData = res.data?.data?.list || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const {
            status,
            name,
            sex,
            phone,
            department_id,
            admin_role_ids,
            job,
            leader_type,
            approver_type,
          } = state.model;

          if (props.id) {
            admin_edit({
              id: props.id,
              status,
              name,
              sex,
              phone,
              department_id,
              admin_role_ids: (admin_role_ids || []).join(","),
              job,
              leader_type: (leader_type || []).join(","),
              approver_type,
            }).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            admin_add({
              status,
              name,
              sex,
              phone,
              department_id,
              admin_role_ids: (admin_role_ids || []).join(","),
              job,
              leader_type: (leader_type || []).join(","),
              approver_type,
            }).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadBm,
      onLoadJs,
    };
  },
};
</script>
<style scoped></style>
